/* eslint-disable */
import React from 'react';
import * as PropTypes from 'prop-types';

import BestCompanyToWorkCard from '../../components/companyCard/bestCompanyToWorkCard';
import styles from './BestCompaniesToWork.module.css';

const defaultProps = {
  topCompaniesData: [],
};

const propTypes = {
  topCompaniesData: PropTypes.arrayOf(PropTypes.object),
};

class BestCompaniesToWork extends React.Component {
  render() {
    const { topCompaniesData } = this.props;
    return (
      <section className="section">
        <div
          className={`best-companies-section container custom-container ${styles['best-companies-container']}`}
        >
          <h2 className="brandonH2 d-flex justify-content-center">Best companies to work for</h2>
          <div>
            <BestCompanyToWorkCard topCompaniesList={topCompaniesData} />
          </div>
        </div>
      </section>
    );
  }
}

BestCompaniesToWork.defaultProps = defaultProps;
BestCompaniesToWork.propTypes = propTypes;

export default BestCompaniesToWork;
